import { FaLink } from 'react-icons/fa';
import './CareerProjects.scss';
import { careerData } from '../../data';
import { MdOutlineArrowBack } from 'react-icons/md';
import { Link } from 'react-router-dom';

const Projects = () => {
  return (
    <div className="projects">
      <div className="projects-back">
        <Link to="/">
          <MdOutlineArrowBack />
        </Link>
      </div>

      {careerData.map((item) => {
        return <ProjectsCard key={item.title} title={item?.title} websiteURL={item?.websiteURL} />;
      })}
    </div>
  );
};

export default Projects;

const ProjectsCard = ({ title, websiteURL }) => {
  return (
    <div className="projects-card">
      <div>
        <h2 className="projects-card-title">{title}</h2>

        <div className="projects-card-links">
          {websiteURL ? (
            <>
              <div className="projects-card-links-box">
                <div className="projects-card-links-box--icon">
                  <FaLink />
                </div>

                <a className="projects-card-links-box--text" href={websiteURL} target="_blank" rel="noreferrer">
                  website
                </a>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
